import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
import simplebar from "simplebar-vue";
// SYSTEM1
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import logoUploadComponent from "./components/LogoUploadComponent.vue";
import { EmailSettingModel } from "@/store/models/organizationSetting/emailSetting";
import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import { OrganizationSettings } from "@/store/modules/organizationSetting.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import { SettingModule } from "@/store/modules/settings.module";
import { FeatureConstants } from "@/store/featureConstants";
import IntegrationConfiguration from "./components/IntegrationComponent.vue";
import OrganizationClockWorkRights from "./components/ClockWorkRightsComponent.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let OrganizationSetting = /** @class */ (() => {
    let OrganizationSetting = class OrganizationSetting extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Organization Settings";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Organization Settings",
                    active: true,
                },
            ];
            this.toEmail = "";
            this.IsPageLoading = false;
            this.organizationSetting = new EmailSettingModel();
            this.emptyGuid = Guid.createEmpty();
            this.activeTab = 0;
        }
        SaveEmail() {
            this.validate("emailSettingObserver").then((response) => {
                if (response) {
                    this.IsPageLoading = true;
                    OrganizationSettings.SaveEmailSettings(this.organizationSetting).then((response) => {
                        this.IsPageLoading = false;
                        if (response) {
                            toaster.ShowSuccess(response.successMessages[0]);
                            this.organizationSetting = this.emailSettings;
                            SettingModule.IsUserHasOrganizationSettingsUpdated(this.emailSettings.isVerified);
                        }
                    });
                }
            });
        }
        VerifyEmail() {
            this.validate("toEmailObserver").then((response) => {
                if (response) {
                    this.IsPageLoading = true;
                    OrganizationSettings.VerifyEmailSetting({ organizationId: this.organizationSetting.organizationSettingId, toEmailId: this.toEmail }).then((response) => {
                        this.IsPageLoading = false;
                        if (response.successMessages.length > 0) {
                            toaster.ShowSuccess(response.successMessages[0]);
                            this.organizationSetting = this.emailSettings;
                            SettingModule.IsUserHasOrganizationSettingsUpdated(this.emailSettings.isVerified);
                        }
                        else {
                            toaster.ShowError(response.warningMessages[0]);
                        }
                    });
                }
            });
        }
        setActiveMenu() {
            var integration = this.$refs.integrationConfiguration;
            integration.setActiveMenu();
        }
        get isEmailSettingsEmpty() {
            return (!this.organizationSetting ||
                !this.organizationSetting.fromMail ||
                !this.organizationSetting.smtpPassword ||
                !this.organizationSetting.smtpPort ||
                !this.organizationSetting.smtpServer ||
                !this.organizationSetting.smtpUsername ||
                this.organizationSetting.id === this.emptyGuid);
        }
        get emailSettings() {
            return OrganizationSettings.emailSetting;
        }
        get TenantLogoUrl() {
            return OrganizationSettings.tenantlogoUrl;
        }
        get hasEmailSettingsChanged() {
            return this.isEmailSettingsEmpty || this.organizationSetting.isVerified;
        }
        get isTenantHasPermeaFeature() {
            return SettingModule.tenantFeatures.length > 0 ? SettingModule.tenantFeatures.some((x) => x.id.toString() == FeatureConstants.Features.Permea().toLowerCase()) : false;
        }
        get isTenantHasClockWorkFeature() {
            return SettingModule.tenantFeatures.length > 0 ? SettingModule.tenantFeatures.some((x) => x.id.toString() == FeatureConstants.Features.ClockWork().toLowerCase()) : false;
        }
        created() {
            OrganizationSettings.GetOrganizationSettings(this.isTenantHasPermeaFeature).then((response) => {
                if (response) {
                    if (this.emailSettings) {
                        this.organizationSetting = this.emailSettings;
                    }
                }
            });
        }
    };
    OrganizationSetting = __decorate([
        Component({
            name: "OrganizationSetting",
            components: {
                Layout,
                PageHeader,
                logoUploadComponent,
                SectionLoader,
                simplebar,
                IntegrationConfiguration,
                OrganizationClockWorkRights,
            },
        })
    ], OrganizationSetting);
    return OrganizationSetting;
})();
export default OrganizationSetting;
